module.exports = __webpack_public_path__ + "static/img/bigWheel2.abd4ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bigWheel2.png
// module id = 65In
// module chunks = 2